/* ===========================================================
   DREAM TO MERCH — GLOBAL THEME JAVASCRIPT
   Cart drawer, hover swap, category pills, smooth scroll
   =========================================================== */

(function() {
  'use strict';

  // ─────────────  CART DRAWER  ─────────────
  const cartIcon = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart(); // refresh cart contents
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartIcon) cartIcon.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ESC to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  // ─────────────  FETCH CART (Shopify Ajax API)  ─────────────
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartBadge(cart.item_count);
      renderCartItems(cart);
    } catch (err) {
      console.error('Cart fetch failed:', err);
    }
  }

  function updateCartBadge(count) {
    const badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(b => {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartItems(cart) {
    const container = document.querySelector('[data-cart-items]');
    if (!container) return;

    if (cart.item_count === 0) {
      container.innerHTML = `
        <div class="cart-empty">
          <p>Your build is empty.</p>
          <a href="/collections/all" class="btn-ghost-dark">Start designing</a>
        </div>`;
      return;
    }

    container.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img src="${item.image}" alt="${item.product_title}" class="cart-item-img">
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-variant">${item.variant_title || ''}</div>
          ${renderDesignInfo(item.properties)}
          <div class="cart-item-price">${formatMoney(item.line_price)}</div>
        </div>
        <button class="cart-item-remove" data-remove-key="${item.key}">×</button>
      </div>
    `).join('');

    // Wire remove buttons
    container.querySelectorAll('[data-remove-key]').forEach(btn => {
      btn.addEventListener('click', async () => {
        await removeFromCart(btn.dataset.removeKey);
      });
    });

    // Update total
    const totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Pay over time (Oct 21): button from the $35 Shop Pay Installments minimum Shopify's banner states, note below it.
    // No installment amount is computed here; Shop Pay shows the real terms at checkout.
    const potBtn = document.querySelector('[data-cart-potbtn]');
    const potNote = document.querySelector('[data-cart-potnote]');
    if (potBtn) potBtn.hidden = cart.total_price < 3500;
    if (potNote) potNote.hidden = cart.total_price >= 3500;
  }

  // Render design info from line item properties (skip hidden properties prefixed with _)
  function renderDesignInfo(properties) {
    if (!properties || Object.keys(properties).length === 0) return '';
    const visible = Object.entries(properties)
      .filter(([k]) => !k.startsWith('_'))
      .map(([k, v]) => `<div class="cart-item-prop"><span>${k}:</span> ${v}</div>`)
      .join('');
    return visible ? `<div class="cart-item-props">${visible}</div>` : '';
  }

  async function removeFromCart(key) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      const cart = await res.json();
      updateCartBadge(cart.item_count);
      renderCartItems(cart);
    } catch (err) {
      console.error('Remove from cart failed:', err);
    }
  }

  // ─────────────  MONEY FORMATTER (cents to display)  ─────────────
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─────────────  PRODUCT CARD HOVER SWAP  ─────────────
  // Cards have <img class="d-img"> (design) and <img class="y-img"> (your design here)
  // CSS handles the fade — this just sets up touch device support
  const productCards = document.querySelectorAll('[data-product-card]');
  productCards.forEach(card => {
    card.addEventListener('touchstart', () => card.classList.add('hover'), { passive: true });
    card.addEventListener('touchend', () => {
      setTimeout(() => card.classList.remove('hover'), 1500);
    });
  });

  // ─────────────  CATEGORY PILLS (filtering)  ─────────────
  const categoryPills = document.querySelectorAll('[data-category-pill]');
  const allProducts = document.querySelectorAll('[data-product-category]');

  categoryPills.forEach(pill => {
    pill.addEventListener('click', (e) => {
      e.preventDefault();
      const filter = pill.dataset.categoryPill;

      categoryPills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');

      allProducts.forEach(product => {
        const cats = product.dataset.productCategory.split(',').map(c => c.trim());
        if (filter === 'all' || cats.includes(filter)) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });
    });
  });

  // ─────────────  SMOOTH SCROLL  ─────────────
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = link.getAttribute('href');
      if (target === '#' || target === '#!') return;
      const el = document.querySelector(target);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ─────────────  INTERSECTION OBSERVER FOR FADE-IN  ─────────────
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('dtm-animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
  }

  // ─────────────  INITIAL CART LOAD  ─────────────
  fetchCart();

  // Expose for inline scripts that need it
  window.DTM = {
    openCart,
    closeCart,
    fetchCart,
    formatMoney
  };
})();
